import styled from "styled-components";

export const Container = styled.footer`
  margin-top: ${({ theme: { layout } }) => layout.sectionGap};

  background-color: ${({ theme: { colors } }) => colors.navy[900]};
  color: rgba(255, 255, 255, 0.78);

  position: relative;
`;

export const MainFooter = styled.div`
  padding: clamp(48px, 6vw, 72px) 0 clamp(36px, 5vw, 56px);
`;

export const RowHolder = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.2fr;
  gap: 48px;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

export const BrandColumn = styled.div``;

export const LogoChip = styled.div`
  display: inline-block;

  background-color: ${({ theme: { colors } }) => colors.white};
  padding: 10px 16px;
  border-radius: ${({ theme: { radii } }) => radii.sm};

  margin-bottom: 20px;
`;

export const BrandText = styled.p`
  max-width: 360px;
  font-size: ${({ theme: { font } }) => font.main};
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.72);
  margin: 0;
`;

export const ColumnTitle = styled.h3`
  font-family: ${({ theme: { font } }) => font.heading};
  font-size: ${({ theme: { font } }) => font.sub};
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);

  margin: 0 0 18px;
`;

export const MenuListHolder = styled.ul`
  margin: 0;
  padding: 0;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 24px;
`;

export const MenuListItem = styled.li`
  a {
    display: inline-block;
    padding: 6px 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: ${({ theme: { font } }) => font.main};

    transition: color ${({ theme: { transition } }) => transition.fast};

    &:hover {
      color: ${({ theme: { colors } }) => colors.main.yellow};
    }
  }
`;

export const ContactColumn = styled.div``;

export const EmailWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;

  color: rgba(255, 255, 255, 0.85);
  font-size: ${({ theme: { font } }) => font.main};

  transition: color ${({ theme: { transition } }) => transition.fast};

  &:hover {
    color: ${({ theme: { colors } }) => colors.main.yellow};
  }

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;

export const AddressHolder = styled.p`
  display: flex;
  align-items: flex-start;
  gap: 10px;

  margin: 14px 0 0;
  max-width: 340px;

  font-size: ${({ theme: { font } }) => font.main};
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.72);

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    margin-top: 4px;
  }
`;

export const TextHolder = styled.span``;

export const SocialHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  margin-top: 24px;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 40px;
    height: 40px;

    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: ${({ theme: { radii } }) => radii.pill};

    color: rgba(255, 255, 255, 0.85);

    transition: background-color ${({ theme: { transition } }) => transition.fast},
      border-color ${({ theme: { transition } }) => transition.fast},
      color ${({ theme: { transition } }) => transition.fast},
      transform ${({ theme: { transition } }) => transition.fast};

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 255, 255, 0.5);
      color: ${({ theme: { colors } }) => colors.main.yellow};
      transform: translateY(-2px);
    }

    svg {
      width: 18px;
      height: 18px;
      stroke-width: 2px;
    }
  }
`;

export const CopyrightWrapper = styled.div`
  padding: 22px 0;

  border-top: 1px solid rgba(255, 255, 255, 0.12);

  font-size: ${({ theme: { font } }) => font.sub};
  color: rgba(255, 255, 255, 0.55);

  a {
    margin-left: 7px;
    text-decoration: underline;
    text-underline-offset: 3px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.75);

    &:hover {
      color: ${({ theme: { colors } }) => colors.main.yellow};
    }
  }
`;
